import { createRouter, createWebHistory } from "@ionic/vue-router";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import TabsPage from "../views/TabsPage.vue";
import RegisterPage from "../views/RegisterPage.vue";
import PetugasPage from "../views/PetugasPage.vue";
import AdminLayout from "../views/AdminLayout.vue";
import PenggunaPage from "../views/PenggunaPage.vue";



const routes = [
  {
    path: "/",
    redirect: "/page",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/LoginPage.vue"),
  },
  {
    path: "/splash",
    name: "splash",
    component: () => import("@/views/SplashScreen.vue"),
  },
  {
    path: "/page/",
    component: TabsPage,
    children: [
      {
        path: "",
        redirect: "/page/home",
      },
      {
        path: "home",
        name: "home",
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
          const auth = getAuth();
          const db = getFirestore();

          const checkUserRole = async (user) => {
            if (user) {
              const userDoc = await getDoc(doc(db, "users", user.uid));
              if (userDoc.exists()) {
                const userData = userDoc.data();
                const userRole = userData.role;

                // Pengalihan berdasarkan peran pengguna
                if (userRole === "admin") {
                  next({ name: "admin" });
                } else if (userRole === "petugas") {
                  next({ name: "petugas" });
                } else {
                  next(); // Pengalihan default jika peran tidak dikenali
                }
              } else {
                next({ name: "login" }); // Pengguna tidak ditemukan di Firestore
              }
            } else {
              next({ name: "login" }); // Pengguna tidak terautentikasi
            }
          };

          onAuthStateChanged(auth, (user) => {
            if (user) {
              checkUserRole(user).catch((error) => {
                console.error(error);
                next({ name: "login" });
              });
            } else {
              next({ name: "login" });
            }
          });
        },
      },

      {
        path: "/petugas",
        name: "petugas",
        component: PetugasPage,
      },
      {
        path: "/pengguna",
        name: "pengguna",
        component: PenggunaPage,
      },
      //approval
      {
        path: "/approval/halamanapproval", 
        name: "halamanapproval",
        component: () => import("@/views/approval/ApprovalPage.vue"),
      },
      {
        path: "/approval/halamanapprovaldetail/:id", 
        name: "halamandetailapproval",
        component: () => import("@/views/approval/ApprovalDetailPage.vue"),
        props: true, 
      },
      // Halaman Petugas
      {
        path: "petugas/laporankehadiran",
        name: "laporankehadiranPetugas",
        component: () => import("@/views/petugas/LaporanKehadiran.vue"),
      },
      {
        path: "petugas/laporanizin",
        name: "laporanizinPetugas",
        component: () => import("@/views/petugas/LaporanIzin.vue"),
      },
      {
        path: "petugas/halamanpengguna",
        name: "halamanpenggunaPetugas",
        component: () => import("@/views/petugas/HalamanPengguna.vue"),
      },
      {
        path: "petugas/halamansetting",
        name: "halamansettingPetugas",
        component: () => import("@/views/petugas/HalamanSetting.vue"),
      },
    ],
  },
  {
    path: "/register",
    name: "register",
    component: RegisterPage,
  },
  {
    path: "/admin",
    component: AdminLayout,
    children: [
      {
        path: "",
        redirect: "/admin/dashboard",
      },
      {
        path: "dashboard",
        name: "admin",
        component: () => import("@/views/AdminDashboard.vue"),
      },
      {
        path: "laporankehadiran",
        name: "laporankehadiranAdmin",
        component: () => import("@/views/admin/LaporanKehadiran.vue"),
      },
      {
        path: "laporangaji",
        name: "laporanGajiAdmin",
        component: () => import("@/views/admin/HalamanGaji.vue"),
      },
      {
        path: "laporanizin",
        name: "laporanizinAdmin",
        component: () => import("@/views/admin/LaporanIzin.vue"),
      },
      {
        path: "halamanpengguna",
        name: "halamanpenggunaAdmin",
        component: () => import("@/views/admin/HalamanPengguna.vue"),
      },
      {
        path: "halamansetting",
        name: "halamansettingAdmin",
        component: () => import("@/views/admin/HalamanSetting.vue"),
      },
    ]
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;